import {
  Checkbox,
  Collapse,
  createSvgIcon,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Typography,
} from "@mui/material";
import { Fragment, useEffect, useState } from "react";

import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { ReactComponent as EasyFlow } from "../../../src/assets/icons/IconEasyFlow.svg";

import { useTheme } from "@emotion/react";
import {
  AttachMoneyOutlined,
  BarChart,
  ConnectWithoutContactOutlined,
  Dashboard,
  Folder,
  HomeOutlined,
  HubOutlined,
  InsertChartOutlined,
  LocalOfferOutlined,
  ManageAccountsOutlined,
  MonitorHeart,
  PermIdentityOutlined,
  Phonelink,
  ReceiptOutlined,
  RequestQuoteOutlined,
  RouterOutlined,
  SecurityOutlined,
  SpaceDashboard,
  SupportAgentOutlined,
  TextSnippetOutlined,
  WorkspacesOutlined,
} from "@mui/icons-material";
import { Box } from "@mui/system";
import useStyles from "./styles";
const OpticalTransceiverIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    {/* Corpo do módulo */}
    <rect
      x="4"
      y="7"
      width="14"
      height="10"
      rx="2"
      ry="2"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
    />

    {/* Porta de conexão (frente do transceptor) */}
    <rect
      x="18"
      y="10"
      width="3"
      height="4"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
    />

    {/* Detalhes internos (contatos) */}
    <line x1="6" y1="9" x2="14" y2="9" stroke="currentColor" strokeWidth="1" />
    <line
      x1="6"
      y1="15"
      x2="14"
      y2="15"
      stroke="currentColor"
      strokeWidth="1"
    />
  </svg>,
  "OpticalTransceiver",
);
const EasyFlowIcon = createSvgIcon(<EasyFlow />);
export default function MenuAcessos(params) {
  const {
    data = [],
    setRoutesSelect = () => {},
    routesSelect = [],
    // Ícones extras/sobrescritos por página (usado pelo portal do cliente)
    iconMap = {},
  } = params;

  const theme = useTheme();
  const styles = useStyles(theme);
  const [checked, setChecked] = useState({});
  const [open, setOpen] = useState({});

  useEffect(() => {
    const parentIds = getParentNodeIds(data);

    const initialState = {};
    parentIds.forEach((id) => {
      initialState[id] = true;
    });

    setOpen(initialState);

    const newChecked = {};

    if (routesSelect.length > 0) {
      const markSelected = (nodes) => {
        nodes.forEach((node) => {
          const isSelected = routesSelect?.some(
            (route) => route?.id === node?.id,
          );

          if (isSelected) {
            newChecked[node?.id] = true;
          }

          if (node.children?.length) {
            markSelected(node?.children);
          }
        });
      };

      markSelected(data);
      data.forEach((root) => updateParentState(root, newChecked));

      setChecked(newChecked);
    }
    // Marca os itens que vieram do routesSelect
  }, [data]);
  useEffect(() => {
    const selectedRoutes = getSelectedRoutes(data, checked);
    setRoutesSelect(selectedRoutes);
  }, [checked, data]);
  const getIconByPage = (pagina) => {
    const map = {
      Home: <HomeOutlined />,
      Dashboard: <BarChart />,
      Overview: <Dashboard />,
      Saúde: <MonitorHeart />,
      Disponibilidade: <Phonelink />,
      "Transceptor óptico": <OpticalTransceiverIcon />,
      ONUs: <RouterOutlined />,
      "Links e Sessões": <HubOutlined />,
      Flow: <EasyFlowIcon />,
      Firewall: <SecurityOutlined />,
      Clientes: <PermIdentityOutlined />,
      "Clientes swap": <ConnectWithoutContactOutlined />,
      Suporte: <SupportAgentOutlined />,
      Métricas: <SpaceDashboard />,
      "Fluxo de atendimento": <InsertChartOutlined />,
      "Fluxo OS": <InsertChartOutlined />,
      OS: <ManageAccountsOutlined />,
      Tickets: <LocalOfferOutlined />,
      Financeiro: <AttachMoneyOutlined />,
      Contratos: <RequestQuoteOutlined />,
      Boletos: <ReceiptOutlined />,
      Relatórios: <TextSnippetOutlined />,
      Reincidência: <InsertChartOutlined />,
      "Cadastro de hosts": <RouterOutlined />,
      "Meu trabalho": <WorkspacesOutlined />,
      ...iconMap,
    };

    return map[pagina] || <Folder />; // fallback
  };
  const getSelectedRoutes = (nodes, checkedMap) => {
    let selected = [];

    nodes.forEach((node) => {
      const state = checkedMap[node.id];

      const isSelected = state === true || state === "indeterminate";

      if (isSelected) {
        selected.push({
          id: node.id,
          path: node.path,
          state,
        });
      }

      if (node.children?.length) {
        selected = selected.concat(
          getSelectedRoutes(node.children, checkedMap),
        );
      }
    });

    return selected;
  };
  const handleToggle = (id) => {
    setOpen((prev) => ({ ...prev, [id]: !prev[id] }));
  };
  const getParentNodeIds = (nodes) => {
    let ids = [];

    nodes.forEach((node) => {
      if (node.children?.length > 0) {
        ids.push(node.id);
        ids = ids.concat(getParentNodeIds(node.children));
      }
    });

    return ids;
  };
  const setChildrenChecked = (node, value, newChecked) => {
    newChecked[node.id] = value;

    if (node.children?.length) {
      node.children.forEach((child) =>
        setChildrenChecked(child, value, newChecked),
      );
    }
  };

  const updateParentState = (node, newChecked) => {
    if (!node.children?.length) return newChecked[node.id] || false;

    const childrenStates = node.children.map((child) =>
      updateParentState(child, newChecked),
    );

    const allChecked = childrenStates.every(Boolean);
    const noneChecked = childrenStates.every((v) => !v);

    if (allChecked) newChecked[node.id] = true;
    else if (noneChecked) newChecked[node.id] = false;
    else newChecked[node.id] = "indeterminate";

    return newChecked[node.id];
  };

  const handleCheck = (node) => {
    const newChecked = { ...checked };
    const currentValue = newChecked[node.id] === true;

    // Marca/desmarca tudo abaixo
    setChildrenChecked(node, !currentValue, newChecked);

    // Atualiza todos os pais
    data.forEach((root) => updateParentState(root, newChecked));

    setChecked(newChecked);
  };

  const renderTree = (nodes) =>
    nodes?.map((node) => {
      const isChecked = checked[node?.id] === true;
      const isIndeterminate = checked[node?.id] === "indeterminate";

      return (
        <Fragment key={node.id}>
          <ListItem button onClick={() => handleToggle(node?.id)}>
            <ListItemIcon>
              <Checkbox
                checked={isChecked}
                indeterminate={isIndeterminate}
                onClick={(e) => {
                  e.stopPropagation();
                  handleCheck(node);
                }}
              />
            </ListItemIcon>
            <Box sx={styles.boxList}>
              <ListItemIcon sx={{ minWidth: "auto", mr: 1 }}>
                {getIconByPage(node.pagina)}
              </ListItemIcon>
              <ListItemText sx={{ minWidth: "auto" }} primary={node.pagina} />
            </Box>

            {node.children?.length > 0 ? (
              open[node.id] ? (
                <ExpandLess />
              ) : (
                <ExpandMore />
              )
            ) : null}
          </ListItem>

          {node.children?.length > 0 && (
            <Collapse in={open[node.id]} timeout="auto" unmountOnExit>
              <List component="div" disablePadding sx={{ pl: 4 }}>
                {renderTree(node.children)}
              </List>
            </Collapse>
          )}
        </Fragment>
      );
    });

  return (
    <>
      <Typography sx={{ display: "block", fontWeight: "bold", mt: 2 }}>
        Selecione as rotas permitidas:
      </Typography>
      <Paper sx={{ borderRadius: "16px" }} variant="outlined">
        <List>{renderTree(data)}</List>
      </Paper>
    </>
  );
}
